import {
  GeneralTickCircle,
  GeneralCrossCircle,
  GeneralHelpCircle,
} from "@fanduel/formation-react-icons";
import cx from "classnames";
import styles from "./marketResult.module.scss";

interface MarketResultProps {
  handicap?: number | string | null;
  odds?: number | string | null;
  hit?: boolean | null;
}

function geMarketResultIcon(hit?: boolean | null) {
  if (hit == null) {
    return <GeneralHelpCircle data-testid="help-circle" />;
  }

  return hit ? (
    <GeneralTickCircle data-testid="tick-circle" />
  ) : (
    <GeneralCrossCircle data-testid="cross-circle" />
  );
}

const MarketResult = ({ handicap, odds, hit }: MarketResultProps) => {
  const icon = geMarketResultIcon(hit);

  // We don't track hit != null here because it doesn't affect the resultInfo
  const noData = odds == null && handicap == null;

  return (
    <div className={styles.marketResult}>
      <div className={styles.resultInfo}>
        {noData ? (
          "-"
        ) : (
          <>
            {handicap && (
              <div className={styles.resultHandicap}>{handicap}</div>
            )}
            {odds && <div className={styles.resultOdds}>{odds}</div>}
          </>
        )}
      </div>
      <div
        className={cx(styles.resultStatus, {
          [styles.hit]: hit,
          [styles.unknown]: hit == null,
        })}
      >
        {icon}
      </div>
    </div>
  );
};

export default MarketResult;
